import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SAJButtonModule } from '@snagajob/button';

import { HubButtonComponent } from './button.component';
import { ButtonPrefixDirective } from './directives/button-prefix.directive';
import { ButtonSuffixDirective } from './directives/button-suffix.directive';

@NgModule({
  imports: [CommonModule, SAJButtonModule],
  declarations: [
    HubButtonComponent,
    ButtonPrefixDirective,
    ButtonSuffixDirective,
  ],
  exports: [HubButtonComponent, ButtonPrefixDirective, ButtonSuffixDirective],
})
export class HubButtonModule {}
